import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import MapLayersVM, { clearListLayerConfig, saveListLayerConfig } from "./MapLayersVM";
import { Button, ButtonGroup } from "@mui/material";

const MapLayersWidget = ({view,activeWidget,mapId}) => {
  const [visible, setVisible] = useState(true);
  const mapLayersDiv = useRef(null);
  const mapLayers = useRef(null)
  

  useEffect(() => {
    if (activeWidget === "mapLayers") {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [activeWidget]);

  useEffect(() => {
    if (mapLayersDiv.current) {
      MapLayersVM(view, mapLayersDiv.current,mapId).then((widget) => {
        mapLayers.current = widget;
      });

      return () => {
        mapLayers.current.destroy();
      };
    }
  }, []);

  let style = { display: "initial" };
  if (visible) {
    style.display = "initial";
  } else {
    style.display = "none";
  }
  return (
  <>
  <ButtonGroup size="small">
  <Button variant="contained" color="secondary" size="small" title="save layer settings" onClick={()=>saveListLayerConfig(view,mapId)}><div className="primary-color-hover">Save layer settings</div></Button>
  <Button color="secondary" size="small" title="default layer settings" onClick={()=>clearListLayerConfig(mapId)}>Default layer settings</Button>
  </ButtonGroup>
  <div ref={mapLayersDiv} style={style}></div>
  </>
  );
};

export default MapLayersWidget;
